import { Skeleton } from "@mui/material";
import { type FC } from "react";

import { ChartXAxisSkeleton } from "../ChartXAxis/ChartXAxisSkeleton";
import * as FooterStyled from "../Footer/Footer.styles";
import { LinearChartSkeleton } from "../LinearChart/LinearChartSkeleton";
import * as LegendStyled from "../MarketsLegend/MarketsLegend.styles";
import * as NewsLegendStyled from "../NewsLegend/NewsLegend.styles";
import * as TopBarStyled from "../TopBar/TopBar.styles";
import { VolumeChartSkeleton } from "../VolumeChart/VolumeChartSkeleton";
import * as Styled from "./CoreChart.styles";

const MARKETS_DROPDOWN = { width: 267, height: 38 };
const VIEW_MODE_WIDTH = 367;
const CHART_ACTIONS = { width: 215, height: 28 };
const RANGE_HEIGHT = 25;
const CHART_INFO = { width: 241, height: 20 };
const SETTINGS_SIZE = 30;

export const CoreChartSkeleton: FC = () => {
  return (
    <Styled.Root>
      <TopBarStyled.Root>
        <Skeleton variant="rounded" {...MARKETS_DROPDOWN} />
        <Skeleton
          variant="rounded"
          width={VIEW_MODE_WIDTH}
          sx={{ height: { xs: 64, md: 28 } }}
        />
        <Skeleton variant="rounded" {...CHART_ACTIONS} />
      </TopBarStyled.Root>

      <LegendStyled.Root>
        <LegendStyled.Row>
          <Skeleton variant="text" width={148} height={18} />
          <Skeleton variant="text" width={96} height={18} />
        </LegendStyled.Row>
      </LegendStyled.Root>

      <NewsLegendStyled.Root>
        <Skeleton variant="text" width={36} height={17} />
        <Skeleton variant="text" width={57} height={18} />
        <Skeleton variant="text" width={63} height={18} />
        <Skeleton variant="text" width={54} height={18} />
      </NewsLegendStyled.Root>

      <Styled.Plot>
        <Styled.LineArea>
          <LinearChartSkeleton />
        </Styled.LineArea>

        <VolumeChartSkeleton />
      </Styled.Plot>

      <ChartXAxisSkeleton />

      <FooterStyled.Root>
        <FooterStyled.RangeSlot>
          <Skeleton
            variant="rounded"
            height={RANGE_HEIGHT}
            sx={{ width: { xs: "100%", sm: 224 } }}
          />
        </FooterStyled.RangeSlot>

        <FooterStyled.Info>
          <Skeleton variant="text" {...CHART_INFO} />
        </FooterStyled.Info>

        <FooterStyled.SettingsSlot>
          <Skeleton
            variant="circular"
            width={SETTINGS_SIZE}
            height={SETTINGS_SIZE}
          />
        </FooterStyled.SettingsSlot>
      </FooterStyled.Root>
    </Styled.Root>
  );
};
